/**
 * Constants for SLADashboard page component
 */

export const TIME_UPDATE_INTERVAL = 60000; // 1 minute in milliseconds

export const AT_RISK_HOURS_THRESHOLD = 12; // Hours threshold for "At Risk" status

export const DEFAULT_ROWS_PER_PAGE = 10;

export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];
